const PLAIN_DECIMAL = /^(\d*)(?:[.,](\d*))?$/;

/**
 * A decimal a person typed into a text field, or null when it is empty,
 * negative or anything but digits with one "." or "," before the fraction.
 *
 * Either separator is a decimal point, so "12,50" and "12.50" both read 12.5
 * in every browser and locale. A fraction longer than `maxFractionDigits` is
 * refused rather than rounded: "1,250" against 2 reads 1.25 to a European and
 * 1250 to an American, and saving either guess is worse than asking again.
 */
export function parseTypedDecimal(
  raw: string,
  maxFractionDigits: number
): number | null {
  const match = PLAIN_DECIMAL.exec(raw.trim());
  if (!match) {
    return null;
  }
  const [, whole = "", fraction = ""] = match;
  const hasDigits = whole !== "" || fraction !== "";
  if (!hasDigits || fraction.length > maxFractionDigits) {
    return null;
  }
  return Number(`${whole || "0"}.${fraction || "0"}`);
}
